// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ABOUT_ME_PROFILE = "O mne";
export const BZ2_counter_PRODUCTS = ["%(counter)s inzer\u00e1t", "%(counter)s inzer\u00e1ty", "%(counter)s inzer\u00e1tov"];
export const EDIT_PROFILE_SETTINGS = "Zme\u0148 \u00fadaje";
export const FORUM_MESSAGES = "v diskusi\u00e1ch";
export const number_FORUM_MESSAGES = ["%(number)s pr\u00edspevok", "%(number)s pr\u00edspevky", "%(number)s pr\u00edspevkov"];
export const number_YEARS = ["%(number)s rok", "%(number)s roky", "%(number)s rokov"];
export const PROFILE_MORE_ABOUT_user = "Viac o %(user)s";
export const PROFILE_REGISTERED_ON_date = "Na Kon\u00edku od %(date)s";
export const PROFILE_VISIT_GROUP_group = "Po\u010f do skupiny %(group)s";
export const SEND_INTERNAL_POST = "Nap\u00ed\u0161 jej intern\u00fa po\u0161tu";
export const TO_ME = "mne";
export const USER_LIKE = "Pridaj k ob\u013e\u00faben\u00fdm";
export const USER_UNLIKE = "Odober z ob\u013e\u00faben\u00fdch";
